import React from "react";
import PropTypes from "prop-types";

export default function LoadMore({
  onLoadMore,
  page: { records, current, initial },
}) {
  if (initial === 0) {
    return null;
  }

  const canLoad = records === current;
  const isLoading = !canLoad && current - records === initial;
  const doneLoading = !canLoad && !isLoading;

  return (
    <div className="row">
      <div className="col s12 m12 l12">
        <ul className="pagination text-right footer-pagination">
          <li className={canLoad ? "waves-effect" : "light-primary-color"}>
            {canLoad && <a onClick={onLoadMore}>Load More&hellip;</a>}
            {isLoading && <a onClick={onLoadMore}>Loading&hellip;</a>}
            {doneLoading && <a>All records loaded.</a>}
          </li>
        </ul>
      </div>
    </div>
  );
}

LoadMore.propTypes = {
  onLoadMore: PropTypes.func,
  page: PropTypes.shape({
    records: PropTypes.number,
    current: PropTypes.number,
    initial: PropTypes.number,
  }),
};
